import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi, ColumnApi, ColDef, GridReadyEvent, RowClickedEvent, CellEditingStoppedEvent, CellEditingStartedEvent, CellFocusedEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { AlertService } from 'src/app/_services/alert.service';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import Swal from 'sweetalert2';
import { Location, UpperCasePipe } from '@angular/common';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { ProductService } from '../product-service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { MenusService } from 'src/app/_services/menu.service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';

export class MaxAmountList {
  "id": number;
  "country": String;
  "countryName": String;
  "maxAmount": String;
  "status" : String;
  "createdBy": String;
  "reviewFlag":boolean;
  "createdOn": String;
  "approvedBy": String;
  "approvedOn": String;
}

export class CountryAmountMapping {
  "countryName" : String;
  "country": number;
  "maxAmount": number;
  "status" : string;
}

export class TypeDataTable {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "serviceChargeType": String;
  "serviceCharge": number;
  "vatType": String;
  "vat": number;
  "effectiveUpdatedDate": String;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
  "type":string;
}


@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss']
})
export class ProductEditComponent implements OnInit {

  @ViewChild('openReviewSlab') private editProductCategoryModal: ModalComponent;
  @ViewChild('reviewCountryMapping') private reviewCountryModal: ModalComponent;
  modalProductReview: ModalConfig;
  reviewCountry : ModalConfig;

  public permissions: any = '';
  private gridApi: GridApi;
  private columnApi: ColumnApi;
  private gridApiDirect: GridApi;
  private gridApiSlab: GridApi;
  activeTab: any = "product";
  selectedFile: SafeUrl = 'assets/images/product.png';
  submitted: boolean = false;
  submittedCommission: boolean = false;
  editProductForm: FormGroup;
  editCommissionForm: FormGroup;
  addSlabPermission : boolean= false;
  permission:String = "EDIT";
  permissionChecker:String = "APPROVE";
  saveButtonVisible : boolean = false;
  maximumAmount: boolean = false;
  maximumAmountText: String;
  typeArray: String[];
  selectedDirect: boolean = false;
  selectedSlab: boolean = false;
  selectedClone : boolean = false;
  selectedCloneType : string = "";
  public maxAmountData !: any[];
  public directData: any[];
  public slabData: any[];
  showOnlySpecific : boolean = false;
  amount: boolean = true;
  maxdata: MaxAmountList;
  countryAmount: CountryAmountMapping;
  countryAmountList: any[];
  idCount: number = 1;
  directTypeData: TypeDataTable;
  slabTypeData: TypeDataTable;
  commissionSlabData: any=[];
  categoryDropdownList: any[];
  subCategoryDropdownList: any[];
  subCategoryName : any;
  categoryName :any;
  savedSlabDataVisible : boolean = false;
  showSlabInformation  : boolean = false;
  public savedData: any[];
  id : any;
  countryDropDown : any[];
  showAddSlabButton : boolean = false;
  oldSlab : any[];
  newSlab : any[];
  slabRemarks : string;
  showOldSlab : boolean = false;
  showNewSlab : boolean = false;
  formDisabled : boolean = false;
  countryRemark : string;
  selectedCountryMapping : any;
  dbStatus : string;
  selectedStatus : string;
  cloneData : any[];
  cloneFinalData : any[];
  cloneStatus :string = "";
  showAddDirectSlabButton : boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public reviewSlabCol: ColDef = {
    flex: 1,
    minWidth: 120,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefsSaved: ColDef[] = [
    {field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false},
    {field: 'toAmount',lockVisible:true,  headerName: 'To Amount', editable:false},
    {field: 'serviceChargeType',lockVisible:true,  headerName: 'Service Charge Type', editable:false},
    {field: 'serviceCharge',lockVisible:true,  headerName: 'Service Charge',editable:false},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'effectiveUpdateDate',lockVisible:true,  headerName: 'Effective Update Date',editable:false},
    {field: 'type',lockVisible:true,  headerName: 'Type', editable:false},
    {field: 'createdBy',lockVisible:true,  headerName: 'Created By', editable:false},
    {field: 'createdOn',lockVisible:true,  headerName: 'Created On' ,editable:false},
    {field: 'approvedBy',lockVisible:true,  headerName: 'Approved By', editable:false},
    {field: 'approvedOn',lockVisible:true,  headerName: 'Approved On', editable:false},
    {field: 'status',lockVisible:true,  headerName: 'Status', editable:false},
    // {
    //   field: 'clone',lockVisible:true,  headerName: 'Clone', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
    //     {
    //       clicked: async (event: any, param: any) => {
    //         console.log(param);
    //         console.log(param.data.type);
    //         this.cloneRow(param.data,param.data.type,param.data.status);
    //       },
    //       buttonIconClass: 'icon-copy',
    //       buttonVisible :false,
    //     },
    //   ],
    // }
 
  ];
  

  public columnDefs: ColDef[] = [
    {
      field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false, cellRenderer: AmountInputCellRenderer
    },
    {
      field: 'toAmount',lockVisible:true,  headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        console.log(params);
        const toAmountValue = parseFloat(params.newValue);
        const maxAmountValue = parseFloat(this.editCommissionForm.value.maxAmount);
        if (!isNaN(toAmountValue) && toAmountValue < maxAmountValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.slabData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
      // ,editable:true
    },
    {
      field: 'serviceChargeType',lockVisible:true,  headerName: 'Service Charge Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }
    },
    { field: 'serviceCharge',lockVisible:true,  headerName: 'Service Charge', cellRenderer: InputCellRenderer },
    // {
    //   field: 'vatType',lockVisible:true,  headerName: 'VAT Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
    //     options: [
    //       { value: 'PERCENTAGE', label: 'PERCENTAGE' },
    //       { value: 'FLAT', label: 'FLAT' },
    //     ]
    //   }, onCellValueChanged: (params: any) => {
    //     const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
    //     if (rowNode) {
    //       this.slabData[params.node.rowIndex].vatType = params.newValue;
    //       this.slabData[params.node.rowIndex].vat = 5;
    //       const newData = { ...rowNode.data, vatType: params.newValue, vat: 5 };
    //       rowNode.setData(newData);
    //       this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
    //     }
    //   }
    // },
    // { field: 'vat',lockVisible:true,  headerName: 'VAT', cellRenderer: InputCellRenderer },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate',lockVisible:true,  headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.slabData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.slabData);
      }
    },

  ];

  public columnDefsDirectSlab: ColDef[] = [
    {
      field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false
    },
    {
      field: 'toAmount',lockVisible:true,  headerName: 'To Amount',editable:false, resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxAmountValue = parseFloat(this.editCommissionForm.value.maxAmount);
        if (!isNaN(toAmountValue) && toAmountValue < maxAmountValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.slabData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    {
      field: 'serviceChargeType',lockVisible:true,  headerName: 'Service Charge Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }
    },
    { field: 'serviceCharge',lockVisible:true,  headerName: 'Service Charge', cellRenderer: InputCellRenderer },
    // {
    //   field: 'vatType',lockVisible:true,  headerName: 'VAT Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
    //     options: [
    //       { value: 'PERCENTAGE', label: 'PERCENTAGE' },
    //       { value: 'FLAT', label: 'FLAT' },
    //     ]
    //   }, onCellValueChanged: (params: any) => {
    //     const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
    //     if (rowNode) {
    //       this.directData[params.node.rowIndex].vatType = params.newValue;
    //       // Reset VAT value when type changes
    //       this.directData[params.node.rowIndex].vat = 5;
    //       const newData = { ...rowNode.data, vatType: params.newValue, vat: 5 };
    //       rowNode.setData(newData);
    //       this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
    //     }
    //   }
    // },
    // { field: 'vat',lockVisible:true,  headerName: 'VAT', cellRenderer: InputCellRenderer },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate',lockVisible:true,  headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.directData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.directData);
      }
    },

  ];

  public maximumRatesCol: ColDef[] = [
    { field: 'countryName',lockVisible:true,  headerName: 'Country', cellClass: 'grid-cell-centered' },
    { field: 'maxAmount',lockVisible:true,  headerName: 'Maximum Product Amount', resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'createdBy',lockVisible:true,  headerName: 'Created By', },
    { field: 'createdOn',lockVisible:true,  headerName: 'Created On' },
    { field: 'approvedBy',lockVisible:true,  headerName: 'Approved By', },
    { field: 'approvedOn',lockVisible:true,  headerName: 'Approved On', },
    { field: 'status',lockVisible:true,  headerName: 'Status', },
    {
      field: 'actions',lockVisible:true,  headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.deleteCountryMapping(param.data);
          },
          buttonIconClass: 'icon-delete',
          buttonVisible : true
        },
        {
          clicked: async (event: any, param: any) => {
            this.approveCountryMapping(param.data);
          },
          buttonIconClass: 'icon-rotate-ccw',
          buttonVisible : false
        },
      ]
    },
    {
      field: 'delete',lockVisible:true,  headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.deleteRow(param.data);
          },
          buttonIconClass: 'icon-delete',
          buttonVisible :false,
        },
      ],
    }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  saveDataTable: ColDef[] = [...(this.columnDefsSaved.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumnDirect: ColDef[] = [...(this.columnDefsDirectSlab.filter((col) => !col?.hide))];
  tableSelectedColumn1: ColDef[] = [...(this.maximumRatesCol.filter((col) => !col?.hide))];

  constructor(private router: Router,private location: Location, private formBuilder: FormBuilder, private alertService: AlertService, private subCategoryService: ProductSubCategoryService, private productService: ProductService,private route: ActivatedRoute,private sanitizer: DomSanitizer,private menuService : MenusService) { }

  ngOnDestroy(){
    console.log("Component Product Destoryed");
    if(this.editProductCategoryModal.isOpen()){
      this.editProductCategoryModal.close();
    } 

    if(this.reviewCountryModal.isOpen()){
      this.reviewCountryModal.close();
    } 
  }
  
  ngOnInit(): void {

    const path = "#/productManagement/productList";
    console.log(path);
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if(this.permissions.includes("View")){
      this.formDisabled = true;
    }
    this.countryAmountList = [];
    // this.maxAmountData = [];
    this.savedData = [];
    this.editProductForm = this.formBuilder.group({
      productImage: ['', Validators.required],
      productName: ['', Validators.required,],
      productDesc: ['', Validators.required],
      productCode: ['',],
      creditType: [''],
      category: [null],
      subCategory: [null],
      status: [null],
      countryProduct: [null]

    })

    
    this.editCommissionForm = this.formBuilder.group({
      country: [null, Validators.required],
      maxAmount: ['', Validators.required],
      type: ['', Validators.required]
    })
    
    this.id = this.route.snapshot.queryParamMap.get("mid");
    this.productService.getProductById(this.id).subscribe((response:any)=>{
      console.log(response);
      this.setProductProfileByApi(response.response.data.icon);
      this.editProductForm.controls.productName.setValue(response.response.data.productName);
      this.editProductForm.controls.productDesc.setValue(response.response.data.productDescription);
      this.editProductForm.controls.productCode.setValue(response.response.data.productCode);
      this.editProductForm.controls.creditType.setValue(response.response.data.creditType);
      this.editProductForm.controls.category.setValue(response.response.data.category);
      this.editProductForm.controls.subCategory.setValue(response.response.data.subCategory);
      this.editProductForm.controls.status.setValue(response.response.data.status);
      this.dbStatus = response.response.data.status;
      this.selectedStatus = response.response.data.status;
      this.categoryName = response.response.data.categoryName;
      this.subCategoryName = response.response.data.subCategoryName;
      this.setCountryMappingList(response.response.data.countryListDTOList,this.permissions);
      this.productService.getSubCategoryDropdownById(response.response.data.category).subscribe((response: any) => {
        this.subCategoryDropdownList = response.response.data;
      });
    })
    

    this.subCategoryService.getCategoryDropdown().subscribe((response: any) => {
      this.categoryDropdownList = response.response.data;
    })

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.modalProductReview = {
      modalTitle: "Product Slab",
      modalSize: 'xl',
      
    
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.reviewCountry = {
      modalTitle: "Product Country Mapping",
      modalSize: 'sm',
      
    
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.editProductForm.get('productImage')?.reset();
  }

  cancelButton() {
    this.router.navigateByUrl('/productManagement/productList')
  }

  categoryChange(category: any) {
    this.categoryName = "";
    if(category == undefined){
      this.editProductForm.controls.subCategory.setValue(null);
      return;
    }
    this.subCategoryDropdownList = [];
    console.log(category.id);
    this.categoryName = category.name;
    this.productService.getSubCategoryDropdownById(category.id).subscribe((response: any) => {
      this.subCategoryDropdownList = response.response.data;
      this.editProductForm.controls.subCategory.setValue(null);
    });

  }

  subCategoryChange(subCategory : any){
    this.subCategoryName = "";
    if(subCategory == undefined){
      return;
    }
    console.log(subCategory.name);
    this.subCategoryName = subCategory.name;
  }

  editProduct(data: any) {
    this.submitted = true;
    if(this.editProductForm.valid){
    console.log("Valid");
    console.log("Profile :" + this.editProductForm.value.productImage);
    console.log("Add Data :" + JSON.stringify(data));

    if (!this.editProductForm.value.creditType) {
      this.editProductForm.value.creditType = false;
    }
    console.log(this.editProductForm.value.creditType);

    if (this.maxAmountData.length == 0) {
      this.alertService.errorAlertWithMessage("Please set country amount mapping");
      return;
    }
    console.log(JSON.stringify(this.countryAmountList));
    let requestForm = {
      "product" : this.id,
      "productName": this.editProductForm.value.productName,
      "productDescription": this.editProductForm.value.productDesc,
      "creditType": this.editProductForm.value.creditType,
      "countryMappingList": this.countryAmountList,
    };

    var requestData = new FormData();
    requestData.append("icon", this.editProductForm.value.productImage);
    requestData.append("request", JSON.stringify(requestForm));
    console.log(requestData);

    this.productService.updateProduct(requestData).subscribe((updateResponse:any)=>{
      console.log(updateResponse);
      if(updateResponse.response.status == 200){
        this.activeTab = "commission";
        console.log("Go Next");
        this.productService.getProductById(this.id).subscribe((response:any)=>{
          console.log(response);
          this.setCountryMappingList(response.response.data.countryListDTOList,this.permissions);
          // this.gridApi.setRowData(this.maxAmountData);
        })
      }else{
        console.log("stay here");
        this.alertService.toastWarringMessageAlertWithMessage("Error while updating the product");
      }
    })
    
    }else{
      console.log("Not Valid");
    }

  }

  editCommission(data: any) {
    this.submittedCommission = true
    if (this.editCommissionForm.valid) {
      if (this.directData.length != 0) {
        console.log(data);
        console.log("Commsion Datatable for Direct : " + JSON.stringify(this.directData));
        this.commissionSlabData = JSON.parse(JSON.stringify(this.directData));
      } else if (this.slabData.length != 0) {
        console.log(data);
        console.log("Commsion Datatable for Slab : " + JSON.stringify(this.slabData));
        this.commissionSlabData = JSON.parse(JSON.stringify(this.slabData));
      }else if (this.directData.length == 0){
        Swal.fire("Please set the slabs",'','error');
        return;
      }else if (this.slabData.length == 0){
        Swal.fire("Please set the slabs",'','error');
        return;
      }
      this.commissionSlabData.map((_:any)=>{
        delete _.isAmountDisabled;
        delete _.type;
      })

      let requestForm = {
        "product": this.id,
        "country": this.editCommissionForm.value.country,
        "type": this.editCommissionForm.value.type,
        "editServiceChargesBodyDTOList": this.commissionSlabData,
      }
      console.log(requestForm);
      var requestData = new FormData();
      requestData.append("request", JSON.stringify(requestForm));
      console.log(requestData);
      this.productService.updateProductSlab(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire(response.response.message, 'Note: Please make sure Exchange Rate Slabs are configured for complete product price .', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/productManagement/productList']);
            } 
          });
        }else{
          Swal.fire(response.response.message, '', 'error');
          return;
        }
      })
    } else {
      console.log("Not Valid");
      return;
    }

  }

  setProductProfileByApi(profile: any) {
    console.log("Choose File "+profile);
    let url = "product/"+profile;
    this.productService.getProfileImage(url).subscribe((response:any)=>{
      console.log(response);
      if(response.type == 'application/json'){
        this.editProductForm.get('productImage')?.setValue(profile);
        this.selectedFile = 'assets/images/product.png';
      }else{
        let file = new File([response], url, { type: response.type });
        console.log(file);
        this.editProductForm.get('productImage')?.setValue(file);
        let imageUrl = URL.createObjectURL(response);
        // let imageUrl = URL.createObjectURL(response);
        this.selectedFile = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
      }
    })

  }

  setProductProfile(profile: any){
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    this.editProductForm.get('productImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);


  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data : " + reader.result);
  }

  switchTab(tab: string): void {
        this.activeTab = tab;
  }

  async countryProductSelect(data:any) {
    if(data == undefined){
      return;
    }
    this.maxdata = new MaxAmountList;
    this.countryAmount = new CountryAmountMapping;
    console.log("Selected Product Country : " + this.editProductForm.value.countryProduct);
    if (this.editProductForm.value.countryProduct != "" && data.id != null) {
      for (let i: number = 0; i < this.maxAmountData.length; i++) {
        if(this.maxAmountData[i].countryName == data.name){
          console.log(this.maxAmountData[i].status);
          if (this.maxAmountData[i].status == "PENDING") {
            this.alertService.errorAlertWithMessage("Please select different country because previous status is PENDING for this country");
            return;
          }else if(this.maxAmountData[i].status == "NEW"){
            this.alertService.errorAlertWithMessage("Please select different country because you cannot add more than one country mapping with NEW status");
            return;
          }
      }
      }
      let inputMaxAmount: HTMLInputElement
      await Swal.fire({
        title: "Please enter the Maximum Amount for " + data.name,
        html: '<input type="text" class="swal2-input" id="maxAmount" placeholder="Enter Max Amount (e.g., 9999.50)" maxlength="15">',
        confirmButtonText: '<span id="confirm-button-text">ADD</span>',
        showCancelButton: true,
        reverseButtons: false,
        allowOutsideClick : false,
        confirmButtonColor: '#f56d1d',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
        didOpen:()=>{
          const popup = Swal.getPopup()!
          inputMaxAmount = popup.querySelector('#maxAmount') as HTMLInputElement
          if (inputMaxAmount) {
            inputMaxAmount.style.width = '90%';
            inputMaxAmount.style.maxWidth = '350px';
            inputMaxAmount.style.padding = '10px';
            inputMaxAmount.style.fontSize = '16px';
          }
          inputMaxAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
          inputMaxAmount.oninput = (event) => {
            const value = (event.target as HTMLInputElement).value;
            const decimalRegex = /^\d*\.?\d{0,2}$/;
            if (value && !decimalRegex.test(value)) {
              (event.target as HTMLInputElement).value = value.slice(0, -1);
            }
          }
        },
        preConfirm: () => {
          console.log(inputMaxAmount.value);
          if(inputMaxAmount.value != ""){
            const value = inputMaxAmount.value.trim();
            const decimalRegex = /^\d+(\.\d{1,2})?$/;
            if (!decimalRegex.test(value)) {
              this.alertService.toastWarringMessageAlertWithMessage("Please enter a valid amount with up to 2 decimal places");
              return;
            }
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue <= 0) {
              this.alertService.toastWarringMessageAlertWithMessage("Please enter a valid positive amount");
              return;
            }
            this.maxdata.id = this.idCount;
            this.maxdata.maxAmount = value;
            this.maxdata.country = data.id;
            this.maxdata.countryName = data.name;
            this.maxdata.status = "NEW";
            this.maxdata.createdBy = "";
            this.maxdata.reviewFlag = true;
            this.maxdata.createdOn = "";
            this.maxdata.approvedBy = "";
            this.maxdata.approvedOn = "";
            this.idCount++;
            this.countryAmount.countryName = data.name;
            this.countryAmount.country = data.id;
            this.countryAmount.maxAmount = numValue;
            this.countryAmount.status = "NEW";
            this.countryAmountList.push(this.countryAmount);
            this.maxAmountData.push(this.maxdata);
            console.log(JSON.stringify(this.maxAmountData));
            this.gridApi.setRowData(this.maxAmountData);
            console.log(this.countryAmountList[0].country);
            this.editProductForm.controls.countryProduct.setValue(null);
          }else{
            this.alertService.toastWarringMessageAlertWithMessage("Please enter max amount");
            return;
          }
        }
      });
    }

  }

  countrySelect(countryId : any) {
  this.addSlabPermission = false;
    this.maximumAmount = false;
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.showAddSlabButton = false;
    this.savedSlabDataVisible = false;
    this.selectedClone = false;
    this.showSlabInformation =false;
    this.savedData = [];
    this.editCommissionForm.controls.type.setValue("");
    console.log("Selected Country : " + this.editCommissionForm.value.country);
    if (this.editCommissionForm.value.country != "" && this.editCommissionForm.value.country != null) {
      this.showAddSlabButton = true;
      console.log("country change");
      this.maximumAmount = true;
      console.log("Country amount : " + this.countryAmountList);
      for (let i: number = 0; i < this.countryAmountList.length; i++) {
        if (this.countryAmountList[i].country == this.editCommissionForm.value.country) {
          this.editCommissionForm.controls.maxAmount.setValue(this.countryAmountList[i].maxAmount);
        }
      }
      this.productService.getProductSlab(this.id,countryId).subscribe((response:any)=>{
        if(response.response.data.serviceChargesBodyDTOList.length == 0){
          this.savedSlabDataVisible = false;
          this.showSlabInformation =true;
        }else{
          this.savedSlabDataVisible = true;
          this.showSlabInformation =false;
          this.savedData = response.response.data.serviceChargesBodyDTOList;
        }
        
      })
      console.log(this.editCommissionForm.value.maxAmount);
    }

  }

  keyFunc(amount: any) {
    this.amount = true;
    console.log(amount.target.value);
    if (amount.target.value) {
      console.log("DATA PRESENT")
      this.amount = false;
    }
  }

  isNumber(input: any) {
    var pattern = /^[0-9]+$/;
    return pattern.test(input);
  }

  typeSelect() {
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.showOnlySpecific = true;
    this.selectedClone = false;
    console.log(this.editCommissionForm.value.type);
    if (this.editCommissionForm.value.type == "DIRECT") {
      this.saveButtonVisible = true;
      this.selectedDirect = true;
      this.directData = [];
      this.showAddDirectSlabButton = true;
      // this.directTypeData = new TypeDataTable;
      // this.directTypeData.fromAmount = 1;
      // this.directTypeData.toAmount = this.editCommissionForm.value.maxAmount;
      // this.directTypeData.serviceChargeType = "PERCENTAGE";
      // this.directTypeData.serviceCharge = 0;
      // this.directTypeData.isAmountDisabled= true;
      // this.directTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
      // this.directData.push(this.directTypeData);
      // this.gridApi.setRowData(this.directData);
    } else if (this.editCommissionForm.value.type == "SLAB") {
      this.saveButtonVisible = true;
      this.selectedSlab = true;
      this.slabData = [];
      // this.slabTypeData = new TypeDataTable;
      // this.slabTypeData.fromAmount = 1;
      // this.slabTypeData.isAmountDisabled = true;
      // this.slabTypeData.toAmount = this.editCommissionForm.value.maxAmount;
      // this.slabTypeData.serviceChargeType = "PERCENTAGE";
      // this.slabTypeData.serviceCharge = 0;
      // this.slabTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
      // this.slabData.push(this.slabTypeData);
      // this.gridApiSlab.setRowData(this.slabData);
    }
  }

  onGridReadyMaxList(params: GridReadyEvent<any>) {
    console.log("Grid Ready");
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
     if (this.permissions.includes("Approve")) {
      console.log("remove action");
      this.columnApi.setColumnsVisible(["delete"], false);
    }else{
      console.log("remove action");
      this.columnApi.setColumnsVisible(["actions"], false);
    }
    console.log("Max Data : "+JSON.stringify(this.maxAmountData))
    this.gridApi.setRowData(this.maxAmountData);
  }

  setCountryMappingList(data:any,permissions:any){
    if(permissions.includes('Approve')){
      this.maxAmountData = [];
      for(let i:number=0;i<data.length;i++){
        this.maxdata = new MaxAmountList;
        this.maxdata.maxAmount = data[i].maxAmount;
        this.maxdata.country = data[i].country;
        this.maxdata.countryName = data[i].countryName;
        if(data[i].status == "PENDING"){
          this.maxdata.reviewFlag = true;
        }else{
          this.maxdata.reviewFlag = false;
        }
        this.maxdata.status = data[i].status;
        this.maxdata.createdBy = data[i].createdBy;
        this.maxdata.createdOn = data[i].createdOn;
        this.maxdata.approvedBy = data[i].approvedBy;
        this.maxdata.approvedOn = data[i].approvedOn;
        this.maxAmountData.push(this.maxdata);
      }
      console.log(JSON.stringify(this.maxAmountData));
    }else{
      this.maxAmountData = [];
      for(let i:number=0;i<data.length;i++){
        this.maxdata = new MaxAmountList;
        this.maxdata.maxAmount = data[i].maxAmount;
        this.maxdata.country = data[i].country;
        this.maxdata.countryName = data[i].countryName;
        this.maxdata.status = data[i].status;
        this.maxdata.createdBy = data[i].createdBy;
        this.maxdata.reviewFlag = false;
        this.maxdata.createdOn = data[i].createdOn;
        this.maxdata.approvedBy = data[i].approvedBy;
        this.maxdata.approvedOn = data[i].approvedOn;
        this.maxAmountData.push(this.maxdata);
      }
      console.log(JSON.stringify(this.maxAmountData));

    }
      this.countryAmountList = [];
      for(let i:number = 0; i< data.length;i++){
        if(data[i].status == "ACTIVE"){
          this.countryAmount = new CountryAmountMapping;
          this.countryAmount.country = data[i].country;
          this.countryAmount.countryName = data[i].countryName;
          this.countryAmount.maxAmount = data[i].maxAmount;
          this.countryAmount.status = data[i].status;
          this.countryAmountList.push(this.countryAmount);
          }
      }
      console.log(JSON.stringify(this.countryAmountList));
      this.gridApi.setRowData(this.maxAmountData);

  }
  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiDirect = params.api
    this.gridApiSlab = params.api

  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }

  deleteRow(countryData: any) {
    console.log(countryData);
    console.log(countryData.status);
    if(countryData.status != "NEW"){
      Swal.fire("You do not have access to delete this country mapping", '', 'error');
      return;
    }
    for (let i: number = 0; i < this.maxAmountData.length; i++) {
      if (this.maxAmountData[i].id == countryData.id) {
        this.maxAmountData.splice(i, 1);
        console.log(this.maxAmountData[i]);
        this.countryAmountList.splice(i, 1);
      }
    }
    console.log(this.maxAmountData);
    this.gridApi.setRowData(this.maxAmountData);
    console.log(this.editProductForm.value.countryProduct);
  }

  addDirectSlab(){
    const newRow = { fromAmount: 1, toAmount: this.editCommissionForm.value.maxAmount, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:"DIRECT" };
    this.directData = [newRow, ...this.directData];
    this.gridApiDirect.setRowData(this.directData);
    this.showAddDirectSlabButton = false;
    return;
  }

  addSlab() {
    for(let i:number = 0;i<this.slabData.length;i++){
      if(this.slabData[i].type == "SLAB" || this.slabData[i].type == "Slab"){
        const newRow = { fromAmount: 1, toAmount: 0, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: false ,type:"SLAB" };
        this.slabData = [newRow, ...this.slabData];
        this.gridApiSlab.setRowData(this.slabData);
        return;
      }
    }
    const newRow = { fromAmount: 1, toAmount: this.editCommissionForm.value.maxAmount, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:"SLAB"};
    this.slabData = [newRow, ...this.slabData];
    this.gridApiSlab.setRowData(this.slabData);
    return;
  }

  
  async selectSpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please Enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">ADD</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        if (inputSpecificAmount) {
          inputSpecificAmount.style.width = '100%';
          inputSpecificAmount.style.maxWidth = '400px';
          inputSpecificAmount.style.padding = '10px';
          inputSpecificAmount.style.fontSize = '16px';
        }
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseFloat(inputSpecificAmount.value) >= parseFloat(this.editCommissionForm.value.maxAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max amount");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), toAmount: Number(inputSpecificAmount.value), serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:"SPECIFIC AMOUNT"};
          if (this.editCommissionForm.value.type == "DIRECT") {
            for(let i:number = 0;i<this.directData.length;i++){
              if(this.directData[i].fromAmount == this.directData[i].toAmount){
                if(this.directData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.directData = [...this.directData, newRow];
            this.gridApiSlab.setRowData(this.directData);
          } else {
            for(let i:number = 0;i<this.slabData.length;i++){
              if(this.slabData[i].fromAmount == this.slabData[i].toAmount){
                if(this.slabData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.slabData = [...this.slabData, newRow];
            this.gridApiSlab.setRowData(this.slabData);
          }
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }

  async onlySpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please Enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">ADD</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        if (inputSpecificAmount) {
          inputSpecificAmount.style.width = '100%';
          inputSpecificAmount.style.maxWidth = '400px';
          inputSpecificAmount.style.padding = '10px';
          inputSpecificAmount.style.fontSize = '16px';
        }
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseFloat(inputSpecificAmount.value) >= parseFloat(this.editCommissionForm.value.maxAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max amount");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), toAmount: Number(inputSpecificAmount.value), serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true };
          if (this.editCommissionForm.value.type == "DIRECT") {
            this.directData = [];
            this.directData = [...this.directData, newRow];
            this.gridApiSlab.setRowData(this.directData);
            this.showOnlySpecific = false;
          } else {
            this.slabData = [];
            this.slabData = [...this.slabData, newRow];
            this.gridApiSlab.setRowData(this.slabData);
            this.showOnlySpecific = false;
          }
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }

  clearTable(type: string) {
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.showOnlySpecific = true;
    if (type == "DIRECT") {
      this.selectedDirect = true;
      this.directData = [];
      this.showAddDirectSlabButton = true;
      this.gridApi.setRowData(this.directData);
    } else if (type == "SLAB") {
      this.selectedSlab = true;
      this.slabData = [];
      this.gridApiSlab.setRowData(this.slabData);
    }else if (type == "CLONE") {
      this.slabData = [];
      this.gridApiSlab.setRowData(this.slabData);
    }
  }

  addSlabCheck(){
    this.selectedClone =false;
    this.saveButtonVisible = false;
    this.slabData = [];
    this.directData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.editCommissionForm.controls.type.setValue("");
    console.log(this.editCommissionForm.value.country);
    if(this.editCommissionForm.value.country != "" && this.editCommissionForm.value.country != null){
      if(this.savedData.length != 0){
        for(let i : number = 0; i<this.savedData.length; i++){
          if(this.savedData[i].status== "PENDING"){
            this.alertService.errorAlertWithMessage("You cannot add new slab because the previous slabs are still in pending");
            this.addSlabPermission = false;
            return;
          }else{
            this.addSlabPermission = true;
          }
        }
      }else{
        this.addSlabPermission = true;
        return;
      }
      
      }else{
      this.addSlabPermission = false;
      this.alertService.errorAlertWithMessage("Please select country to set Slab");
      return;
    }
   
  }
  cloneRow(data:any,type:any,status:any){
    if(this.cloneStatus == ""){
      this.cloneStatus = status;
    }else if(this.cloneStatus != status){
      this.alertService.toastWarringMessageAlertWithMessage("Please clone only "+this.cloneStatus+" Slab");
      return;
    }
    
    console.log(type);
    if(type == "Slab"){
      const newRow = { fromAmount: data.fromAmount, toAmount: data.toAmount, serviceChargeType: data.serviceChargeType, serviceCharge: data.serviceCharge, vatType: data.vatType || "PERCENTAGE", vat: data.vat !== undefined ? data.vat : 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:type||UpperCasePipe  };
      this.slabData = [newRow, ...this.slabData];
      this.gridApiSlab.setRowData(this.slabData);
      console.log(this.slabData);
      return;
    }else if(type == "Direct"){
      const newRow = { fromAmount: data.fromAmount, toAmount: data.toAmount, serviceChargeType: data.serviceChargeType, serviceCharge: data.serviceCharge, vatType: data.vatType || "PERCENTAGE", vat: data.vat !== undefined ? data.vat : 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:type||UpperCasePipe  };      this.slabData = [newRow, ...this.slabData];
      this.gridApiSlab.setRowData(this.slabData);
      console.log(this.slabData);
      return;
    }else if(type == "Specific Amount"){
      const newRow = { fromAmount: data.fromAmount, toAmount: data.toAmount, serviceChargeType: data.serviceChargeType, serviceCharge: data.serviceCharge, vatType: data.vatType || "PERCENTAGE", vat: data.vat !== undefined ? data.vat : 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:type||UpperCasePipe };      this.slabData = [newRow, ...this.slabData];
      this.gridApiSlab.setRowData(this.slabData);
      console.log(this.slabData);
      return;
    }
  }

  cloneSavedData(){
    this.cloneData = [];
    this.cloneFinalData = [];
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.addSlabPermission = false;
    this.selectedClone = false;
    this.editCommissionForm.controls.type.setValue("");
    if(this.editCommissionForm.value.country != "" && this.editCommissionForm.value.country != null){
      if(this.savedData.length != 0){
        for(let i : number = 0; i<this.savedData.length; i++){
          if(this.savedData[i].status== "PENDING"){
            this.alertService.errorAlertWithMessage("You cannot clone slab because the previous slabs are still in pending");
            this.selectedClone = false;
            return;
          }
        }
            console.log(this.savedData);
            // this.selectedClone = true;
            this.saveButtonVisible = true;
            this.cloneData = JSON.parse(JSON.stringify(this.savedData));
            this.cloneFinalData = this.cloneData.filter((_ : any)=>{
              console.log(_.type);
              if(_.type == "Direct"){
                this.selectedCloneType = "DIRECT";
              }else{
                this.selectedCloneType = "SLAB";
              }
              return _.status=="ACTIVE"
            }).map((_: any) => {
              _.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
              _.isAmountDisabled = true;
              if(!_.vatType) {
                _.vatType = "PERCENTAGE";
              }
              if(_.vat === undefined || _.vat === null) {
                _.vat = 5;
              }
              delete _.status;
              delete _.approvedBy;
              delete _.approvedOn;
              delete _.createdBy;
              delete _.createdOn;
              delete _.effectiveUpdateDate;
              // delete _.type;
              return _;
            });
            if(this.selectedCloneType == "DIRECT"){
              this.saveButtonVisible = true;
              this.selectedDirect = true;
              this.directData = [];
              this.directData = this.cloneFinalData;
              this.showAddDirectSlabButton = false;
            }else if(this.selectedCloneType == "SLAB"){
              this.saveButtonVisible = true;
              this.selectedSlab = true;
              this.slabData = [];
              this.slabData = this.cloneFinalData;
            }
            console.log(this.slabData);
            this.editCommissionForm.controls.type.setValue(this.selectedCloneType);
      }else{
        this.alertService.errorAlertWithMessage("No slabs to be clone");
      }
      }else{
      this.addSlabPermission = false;
      this.alertService.errorAlertWithMessage("Please select country to set Slab");
      return;
    }
  }

  nextButton(){
    this.activeTab ="commission";
  }

  async approveCountryMapping(data : any) {
    if(data.status == "ACTIVE"){
      return;
    }
    this.countryRemark = "";
    this.selectedCountryMapping = "";
    this.reviewCountryModal.open();
    this.selectedCountryMapping = data;
  }

  reviewSlab(event:any){
    event.target.blur()
    this.showOldSlab = false;
    this.showNewSlab = false;
    this.oldSlab = [];
    this.newSlab = [];
    this.slabRemarks = "";
    if(this.editCommissionForm.value.country != "" && this.editCommissionForm.value.country != null){
      for(let i : number = 0; i<this.savedData.length; i++){
        if(this.savedData[i].status== "ACTIVE"){
          this.oldSlab.push(this.savedData[i]);
        }else if(this.savedData[i].status== "PENDING"){
          this.newSlab.push(this.savedData[i]);
        }
      }
    if(this.oldSlab.length == 0){
      this.showOldSlab = false;
    }else{
      this.showOldSlab = true;
    }

    if(this.newSlab.length == 0){
      this.showNewSlab = false;
      this.alertService.errorAlertWithMessage("Nothing to Review");
    }else{
      this.showNewSlab = true;
      this.editProductCategoryModal.open();
    }

    
    }else{
      this.alertService.errorAlertWithMessage("Please select country");
    }
  }

  approveSlab(){
    console.log("Approved");
    console.log(this.slabRemarks);
    if(this.slabRemarks == "" || this.slabRemarks == undefined || this.slabRemarks == null){
      Swal.fire('Please Enter the Remarks', '', 'error')
      return;
    }
    let requestForm = {
      "product" : this.id,
      "country" : this.editCommissionForm.value.country,
      "status" : "ACTIVE",
      "remark" : this.slabRemarks
    }
    this.productService.reviewProductSlab(requestForm).subscribe((response:any)=>{
      console.log(response)
      if(response.response.status == 200){
        this.editProductCategoryModal.close();
        Swal.fire(response.response.message, '', 'success');
        this.productService.getProductSlab(this.id,this.editCommissionForm.value.country).subscribe((response:any)=>{
          console.log(response);
          if(response.response.data.serviceChargesBodyDTOList.length == 0){
            this.savedSlabDataVisible = false;
          }else{
            this.savedSlabDataVisible = true;
            this.savedData = response.response.data.serviceChargesBodyDTOList;
          }

        })
      }else{
        this.editProductCategoryModal.close();
        Swal.fire(response.response.message, '', 'error');
      }
    })
  }


  rejectSlab(){
    console.log("Rejected");
    console.log(this.slabRemarks);
    if(this.slabRemarks == "" || this.slabRemarks == undefined || this.slabRemarks == null){
      Swal.fire('Please Enter the Remarks', '', 'error')
      return;
    }
    let requestForm = {
      "product" : this.id,
      "country" : this.editCommissionForm.value.country,
      "status" : "REJECTED",
      "remark" : this.slabRemarks
    }
    this.productService.reviewProductSlab(requestForm).subscribe((response:any)=>{
      console.log(response)
      if(response.response.status == 200){
        this.editProductCategoryModal.close();
        Swal.fire(response.response.message, '', 'success');
        this.productService.getProductSlab(this.id,this.editCommissionForm.value.country).subscribe((response:any)=>{
          console.log(response);
          if(response.response.data.serviceChargesBodyDTOList.length == 0){
            this.savedSlabDataVisible = false;
          }else{
            this.savedSlabDataVisible = true;
            this.savedData = response.response.data.serviceChargesBodyDTOList;
          }

        })
        
      }else{
        this.editProductCategoryModal.close();
        Swal.fire(response.response.message, '', 'error');
      }
    })

  }

  reviewCountryStatus(status : string){
    console.log(status);
    console.log(this.countryRemark)
    console.log(this.selectedCountryMapping);
    if(this.countryRemark != "" && this.countryRemark != undefined){
    let requestForm = {
      "product" : this.id,
      "country" : this.selectedCountryMapping.country,
      "status" : status,
      "remarks" : this.countryRemark,
    }
      this.productService.reviewCountryMapping(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          this.reviewCountryModal.close();
          Swal.fire(response.response.message, '', 'success');
          this.productService.getProductById(this.id).subscribe((response:any)=>{
            console.log(response);
            this.setCountryMappingList(response.response.data.countryListDTOList,this.permissions);
            // this.gridApi.setRowData(this.maxAmountData);
            
          })
        }else{
          this.reviewCountryModal.close();
          Swal.fire(response.response.message, '', 'error');
        }
      })    
    }else{
      this.alertService.toastWarringMessageAlertWithMessage("Remark is required");
    }
  }


  isAlphanumeric(str:string) {
    return /^[a-zA-Z0-9]*$/.test(str);
  }

  // Method to validate product code input (only alphanumeric and underscore allowed)
  onProductCodeKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9) and underscore (_)
    const pattern = /^[a-zA-Z0-9_]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate product name input (alphanumeric, underscore, and spaces allowed)
  onProductNameKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate product description input (alphanumeric, underscore, and spaces allowed)
  onProductDescKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  async deleteCountryMapping(countryData :any){
    console.log(countryData);
  await Swal.fire({
    title: "Are you sure ?",
    text: "This action will impact the active users as they won't be able to use the product for "+countryData.countryName,
    confirmButtonText: '<span id="confirm-button-text">Delete</span>',
    showCancelButton: true,
    reverseButtons: false,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#7987a1',
    customClass: {
      confirmButton: 'swal2-confirm-custom',
      cancelButton: 'swal2-cancel-custom'
    },
  }).then((result) => {
    if (result.isConfirmed) {
      console.log(this.id);
      console.log(countryData.country);
      console.log(countryData.status);
      this.productService.deleteCountryMapping(this.id,countryData.country).subscribe((response:any)=>{
        console.log(response)
        if(response.response.status == 200){
          Swal.fire(response.response.message, '', 'success');
          this.productService.getProductById(this.id).subscribe((response:any)=>{
            console.log(response);
            this.setCountryMappingList(response.response.data.countryListDTOList,this.permissions);
            // this.gridApi.setRowData(this.maxAmountData);
          })
        }else{
          Swal.fire(response.response.message, '', 'error');
        }
      })
    }
  });

  }

  statusChange(status : any){
    this.selectedStatus = status;
    if(this.selectedStatus == "INACTIVE"){
      Swal.fire({
        title: "Are you sure?",
        text : "This action will impact the active users as they won't be able to use the product anymore",
        showCancelButton: true,
        confirmButtonText: '<span id="confirm-button-text">Confirm</span>',
        confirmButtonColor:'#f56d1d',
        cancelButtonColor : '#d33',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.editProductForm.controls.status.setValue("INACTIVE");
        } else{
          this.editProductForm.controls.status.setValue(null);
        }
      });
    }else{
      return;
    }


  }

  onCellValueChanged(params:any){
    console.log(params.value);
    console.log(params.column.colId);
    if(params.value == "FLAT" || params.value == "PERCENTAGE"){
      if(this.editCommissionForm.value.type == "DIRECT"){
        this.directData[params.rowIndex].serviceCharge = 0;
        this.gridApiDirect.setRowData(this.directData);
        return;
      }else if(this.editCommissionForm.value.type == "SLAB"){
        this.slabData[params.rowIndex].serviceCharge = 0;
        this.gridApiSlab.setRowData(this.slabData);
        return;
      }
    }

    if(params.column.colId == "serviceCharge"){
      const serviceChargeInput = params.data.serviceCharge;
        if(serviceChargeInput === null || serviceChargeInput === undefined || serviceChargeInput === "" || serviceChargeInput === "."){
        return;
      }
      
      const serviceChargeString = serviceChargeInput.toString().trim();
      const decimalParts = serviceChargeString.split('.');
      if(decimalParts.length > 1 && decimalParts[1].length > 2){
        const truncatedValue = parseFloat(decimalParts[0] + '.' + decimalParts[1].substring(0, 2));
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("Service Charge can only have up to 2 decimal places");
          this.directData[params.rowIndex].serviceCharge = truncatedValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("Service Charge can only have up to 2 decimal places");
          this.slabData[params.rowIndex].serviceCharge = truncatedValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      const serviceChargeValue = parseFloat(serviceChargeString);
      
      if(params.data.toAmount == 0 || params.data.toAmount == "0"){
        this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'To Amount'");
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].serviceCharge = 0;
          this.gridApiDirect.setRowData(this.directData);
          return;
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].serviceCharge = 0;
          this.gridApiSlab.setRowData(this.slabData);
          return;
        }
      }else{
        if(params.data.serviceChargeType == "PERCENTAGE"){
          if(isNaN(serviceChargeValue) || serviceChargeValue < 0){
            if(this.editCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage must be a valid number greater than or equal to 0");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.editCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage must be a valid number greater than or equal to 0");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
          if(serviceChargeValue >= 100){
            if(this.editCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage cannot be 100%. Please enter a value less than 100.");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.editCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage cannot be 100%. Please enter a value less than 100.");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
        }else if(params.data.serviceChargeType == "FLAT"){
          const toAmountValue = parseFloat(params.data.toAmount);
          if(serviceChargeValue > toAmountValue){
            if(this.editCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'TO AMOUNT'");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.editCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'TO AMOUNT'");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
        }
      }

    }else if(params.column.colId == "vat"){
      const vatInput = params.data.vat;
      if(vatInput === null || vatInput === undefined || vatInput === "" || vatInput === "."){
        return;
      }
      const vatString = vatInput.toString().trim();
      const vatDecimalParts = vatString.split('.');
      if(params.data.vatType == "FLAT"){
        if(vatDecimalParts.length > 1){
          if(this.editCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows whole numbers (0-99)");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.editCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows whole numbers (0-99)");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        
        const vatValue = parseFloat(vatString);
        if(isNaN(vatValue)){
          const previousValue = params.oldValue !== undefined ? params.oldValue : 5;
          if(this.editCommissionForm.value.type == "DIRECT"){
            this.directData[params.rowIndex].vat = previousValue;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.editCommissionForm.value.type == "SLAB"){
            this.slabData[params.rowIndex].vat = previousValue;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        if(vatValue > 99){
          if(this.editCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows 2 digits (0-99)");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.editCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows 2 digits (0-99)");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        
        if(vatValue < 0){
          if(this.editCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.editCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        const wholeNumber = Math.floor(vatValue);
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].vat = wholeNumber;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].vat = wholeNumber;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
        }
        return;
      }
      if(vatDecimalParts.length > 1 && vatDecimalParts[1].length > 2){
        const truncatedValue = parseFloat(vatDecimalParts[0] + '.' + vatDecimalParts[1].substring(0, 2));
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT can only have up to 2 decimal places");
          this.directData[params.rowIndex].vat = truncatedValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT can only have up to 2 decimal places");
          this.slabData[params.rowIndex].vat = truncatedValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      const vatValue = parseFloat(vatString);
      if(isNaN(vatValue)){
        const previousValue = params.oldValue !== undefined ? params.oldValue : 5;
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].vat = previousValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].vat = previousValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      if(vatValue < 0){
        if(this.editCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
          this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.editCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
          this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      if(params.data.vatType == "PERCENTAGE"){
        if(vatValue >= 100){
          if(this.editCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Percentage cannot be 100% or greater. Please enter a value less than 100.");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.editCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Percentage cannot be 100% or greater. Please enter a value less than 100.");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
      }
    }else{
      return;
    }
}

statusChangeApi(){
  if(this.selectedStatus == undefined){
    Swal.fire('Please select Status','','error');
    return;
  }
  if(this.dbStatus == this.selectedStatus){
    Swal.fire('Status is already '+this.selectedStatus,'','error');
  }else{
    this.productService.productStatusChange(this.id,this.selectedStatus).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire('Status Updated Successfully','','success');
      }else{
        Swal.fire(response.response.message,'','error');
      }
    })
  }
}

// onCellEditingStopped(e : CellEditingStoppedEvent){
//   console.log(e.data.fromAmount);
//   console.log(e.data.toAmount);
//   if(Number(e.data.fromAmount)>Number(e.data.toAmount)){
//     console.log(e.node.rowIndex);
//     if(e.node.rowIndex){
//       const rowNode = this.gridApiSlab.getRowNode((e.node.rowIndex + 1).toString());
//       console.log(rowNode);
//       if (rowNode) {
//         this.slabData[e.node.rowIndex].toAmount = e.oldValue
//         const newData = { ...rowNode.data, toAmount: e.oldValue };
//         rowNode.setData(newData);
//         this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
//       }
//       this.gridApiSlab.setFocusedCell(e.node.rowIndex, "toAmount")
//       this.gridApiSlab.startEditingCell({rowIndex: e.node.rowIndex, colKey: "toAmount"})
//     }
//   }
// }


}
